import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { provideFirebase } from './firebase';
import { ThemeService } from './shared/theme.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideFirebase(),
    // Instantiate ThemeService at bootstrap so its effect on the user's
    // theme preference is wired before the shell mounts and the very
    // first render reflects the right tokens.
    provideAppInitializer(() => {
      inject(ThemeService);
    }),
  ],
};
